import { API } from "../../backend";

export const getFilteredPlaylists = (search, page, limit, sort, data) => {
  return fetch(
    `${API}/playlist/getFilteredPlaylists/?category=${search}&page=${page}&limit=${limit}&sort=${sort}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }
  )
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};
export const getFilteredPlaylists2 = (search, page, limit, sort, data) => {
  return fetch(
    `${API}/playlist/getFilteredPlaylists/?search=${search}&page=${page}&limit=${limit}&sort=${sort}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }
  )
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};

export const getPlaylistsByRandomCategory = () => {
  return fetch(`${API}/playlist/getrandom`, {
    method: "GET",
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};

export const getPlaylistsByCategory = (data) => {
  return fetch(`${API}/playlist/search`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};
